
import { Injectable, NgZone, Inject, PLATFORM_ID } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { LocalizeRouterService } from 'localize-router';
import { AuthService } from '../_services/auth.sevice';

@Injectable()
export class HttpErrorsInterceptor implements HttpInterceptor {


  constructor(@Inject(PLATFORM_ID) platformId, private router: Router, private localize: LocalizeRouterService, private auth: AuthService) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  isBrowser: boolean;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return this.isBrowser ?
    next.handle(request).pipe(
      tap((res: any) => {

        if (res.body && res.body.descrizione === 'Invalid session' && this.auth.isLogged) {
          console.log ('URL:  ', res.url, ' \nBody: ', JSON.stringify(res.body), ' \n SESSIONE NON VALIDA ');
          this.auth.svuotaStorage();
          this.router.navigate([this.localize.translateRoute('/login')], {queryParams: { returnUrl: window.location.href }});
          return;
        }


        if ( res && res.body && res.body.esito && res.body ) {
          if ( res.body.esito === 'OK' ) {
            console.log ('URL:  ', request.url, '\nBody: ', request.body, '\nResp: ', res.body.result);
          } else {
            console.log ('URL:  ', request.url, ' \nBody: ', JSON.stringify(request.body), '\nErrore: ', res.body.descrizione + ' - ' +  JSON.stringify(res.body.result));
          }
        }
      }, error => {
        if (error.status !== 511) {
          alert(error.message);
        }
      })
    )
    :
    next.handle(request).pipe(
      tap((res: any) => {
        if ( res && res.body && res.body.esito && res.body ) {
          if ( res.body.esito === 'OK' ) {
            // console.log ('URL:  ' + request.url, '\nBody: ' + request.body  + '\nResp: ' + JSON.stringify(res.body.result));
          } else {
            console.log ('URL:  ', request.url + ' \nBody: ' + JSON.stringify(request.body), '\nErrore: ' + JSON.stringify(res.body.result));
          }
        }
      }, error => {
        console.log('Error!!!! HttpErrorsInterceptor ' + error );
      })
    );
  }
}
